import React, { useContext, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import { runInAction } from "mobx";
import { selectRoute } from "src/config/routes";
import { RootStoreContext } from "src/stores/RootStore";
import { Route } from "src/config/routes";
import { RouterProps } from "react-router";
import { Link } from "react-router-dom";

export const EmailChange = (props: RouterProps) => {
    const { t } = useTranslation();
    const { navStore, uiStore } = useContext(RootStoreContext);

    useEffect(() => {
        runInAction(() => {
            navStore.setTitle(t("screens.auth.newemail.change.title"));
            navStore.setBackbutton(selectRoute(Route.profile), t("screens.account.title").toString());
        });
    }, [navStore, uiStore, t]);

    return (
        <UI.Container className="pt-4">
            <UI.Row>
                <UI.Col xs={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
                    <UI.Card title={t("screens.auth.newemail.change.title").toString()}>
                        <span>
                            <Trans
                                i18nKey="screens.auth.newemail.change.moved_notice"
                                components={{
                                    1: <Link style={{ display: "inline" }} to={Route.communicationSettings} />
                                }}
                            />
                        </span>
                    </UI.Card>
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};
